// @ts-nocheck
import path from 'path'
import { wlodevCloudEnabled } from '../config.js'
import { getPackageManager } from '../getPackageManager.js'

const packageManager = getPackageManager({
    projectDir: path.resolve(process.cwd(), '../../'),
})

let commandPrefix = ''
switch (packageManager) {
    case 'yarn':
        commandPrefix = 'yarn'
        break
    case 'pnpm':
        commandPrefix = 'pnpm'
        break
    case 'bun':
        commandPrefix = 'bun'
        break
    default:
        commandPrefix = 'npm run'
        break
}

export const withWlodev = (nextConfig: any = {}) => {
    return {
        ...nextConfig,
        basePath: wlodevCloudEnabled ? '/cms' : '',
        rewrites: async () => {
            return [
                ...(nextConfig.rewrites ?? []),
                ...(wlodevCloudEnabled
                    ? []
                    : [
                          {
                              source: '/:admin*',
                              destination: `/:admin*`,
                          },
                          {
                              source: '/:path*',
                              destination: `http://localhost:4321/:path*`,
                          },
                      ]),
            ]
        },
    }
}
